import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { SIGN_IN } from 'config/url';

import Field from 'components/Field';
import Button from 'components/Button';

const SignIn = ({onSubmit}) => {
  const { handleSubmit, register, formState: { errors } } = useForm();
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field label="Nom" type="text"
        register={
          register("last_name", {
            required: true,
          })
        }
      />
      <Field label="Prénom" type="text"
        register={
          register("first_name", {
            required: true,
          })
        }
      />
      <Field label="Date de naissance" type="date"
        register={
          register("birth_date", {
            required: true,
          })
        }
      />
      <Field label="Email" type="text"
        register={
          register("email", {
            required: true,
          })
        }
      />
      <Field label="Mot de passe" type="password"
        register={
          register("password", {
            required: true,
          })
        }
      />
      <Field label="Confirmer le mot de passe" type="password"
        register={
          register("password_confirmation", {
            required: true,
          })
        }
      />
      <Field label="Accepter les CGU" type="checkbox"
        register={
          register("accepted_cgu", {
            required: true,
          })
        }
      />
      <div className="has-text-centered">
        <Button type="submit" className="is-primary">
          S'inscrire
        </Button>
      </div>
      <div className="has-text-centered mt-5">
        <Link to={SIGN_IN}>
          Se connecter ?
        </Link>
      </div>
    </form>
  );
}

export default SignIn;